import React, { useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { CreatorsLayout, MainLayout } from "../components";
import { HelpPage, InvitedUsersPage, ProfileView } from "../pages";

export default function CreatorModule() {
  return (
    <MainLayout>
      <Routes path="">
        <Route path="/" element={<InvitedUsersPage />} />
        <Route path="profile/:id" element={<ProfileView />} />
        <Route path="*" element={<InvitedUsersPage />} />
      </Routes>
    </MainLayout>
  );
}
